export const CLASSIFICATION_MISMATCH_MESSAGE = "区分が空欄か、求人の区分と異なっています。";
export const RESIDENCE_EXPIRING_SOON_MESSAGE = "在留期限が1ヶ月以内となりましたのでご確認ください。";
export const RESIDENCE_EXPIRED_MESSAGE = "在留期限が切れておりますので、ご確認ください。";
export const PASSPORT_EXPIRING_SOON_MESSAGE = "パスポート期限が1ヶ月以内となりましたのでご確認ください。";
export const PASSPORT_EXPIRED_MESSAGE = "パスポート期限が切れておりますので、ご確認ください。";
export const WARNING_CHANGE_STATUS_MESSAGE = "ステータスを変更できません。「マッチング情報を確認」から必須項目を入力してください。";
